import { destinationPagePublicPath, legacyDestinationPagePublicPath } from '@utazzo/shared';

/**
 * Public website origin for the "view on site" links in admin lists.
 *
 * Set `VITE_SITE_URL` in the root `.env` to the environment whose data this
 * admin writes - e.g. `http://localhost:3001` for the local apps/website dev
 * server, or your staging/prod origin. Falls back to the production domain.
 */
export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string | undefined)?.replace(/\/$/, '') ||
  'https://www.utazzo.com';

/** Public URL for a package: /package-itinerary/<slug> */
export const packagePublicUrl = (slug: string): string => `${SITE_URL}/package-itinerary/${slug}`;

/** Public URL for a category roll-up page: /<slug> */
export const categoryPublicUrl = (slug: string): string => `${SITE_URL}/${slug}`;

/**
 * Public URL for a destination page: /<primary-category>/<slug>, or the legacy
 * flat /destinations/<slug> when no category has been linked yet.
 */
export const destinationPublicUrl = (slug: string, primaryCategorySlug?: string | null): string =>
  `${SITE_URL}${
    primaryCategorySlug
      ? destinationPagePublicPath(primaryCategorySlug, slug)
      : legacyDestinationPagePublicPath(slug)
  }`;
